export const INTERNAL_NOTES = {
    NOTES_INPUT: "notes-input",
    ADD_NOTE: "add-note",
    NOTE_ENTRY: "note-entry",
    INTERNAL_NOTES: "internal_notes",
};
